import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-level",
  "use": "icon-more-level-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-level\"><path d=\"M458.667 512a53.333 53.333 0 1 0 106.666 0 53.333 53.333 0 1 0-106.666 0zM149.333 512A53.333 53.333 0 1 0 256 512a53.333 53.333 0 1 0-106.667 0zM768 512a53.333 53.333 0 1 0 106.667 0A53.333 53.333 0 1 0 768 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/more-level.svg
// module id = i805
// module chunks = 65